import { z } from 'zod';
import { IdSchema } from '../resource-base/baseSchemas';
import { msObject } from '../resource-base/msObject';
import { VersionInfoSchema } from '../services/versionInfo';

// const VersionNodeVariantStatusSchema = z.enum(VersionNodeVariantStatus);

/* const GraphDiagramVariantOutlineSchema = NamedArtifactOutlineSchema.extend({
    status: VersionNodeVariantStatusSchema,
}); */

export const GraphDiagramOutlineSchema = msObject({
    versionId: IdSchema,
    versionInfo: VersionInfoSchema,
    description: z.string().nullable(),
    get newerVersions() {
        return GraphDiagramOutlineSchema.array();
    },
    isPublished: z.boolean(),
});

// export type GraphDiagramVariantOutline = z.infer<typeof GraphDiagramVariantOutlineSchema>;
export type GraphDiagramOutline = z.infer<typeof GraphDiagramOutlineSchema>;
